/**
 * Referral landing page — /ref/:code
 *
 * Stores the referral code in localStorage so it persists across the
 * registration flow, then immediately redirects to /auth?tab=register.
 *
 * Anti-self-referral enforcement is on the backend. The frontend just
 * stores the code and passes it to the register API call.
 *
 * Rate limiting: 10 registrations/minute enforced by backend.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/ref/$code")({
  // Server-side: store the code in a cookie-safe way via redirect.
  // Client-side: localStorage is more reliable for SPA flows.
  beforeLoad: ({ params }) => {
    if (typeof window !== "undefined" && params.code) {
      // Validate code format: 8 alphanumeric chars max
      if (/^[a-z0-9_-]{4,12}$/i.test(params.code)) {
        localStorage.setItem("vh_ref_code", params.code);
        localStorage.setItem("ref_code", params.code);
      }
    }
    throw redirect({ to: "/auth", search: { tab: "register" }, replace: true });
  },
  component: () => null,
});
